import React from 'react';
import type { LogDescription } from 'ethers/lib/utils';
import type { Block } from '@ethersproject/abstract-provider';

export type EventsContextValue = {
  events?: {
    hash: string;
    contractAddress: string;
    log: LogDescription;
    block: Block;
  }[];
  fetchEvents: () => void;
};

const EventsContext = React.createContext<EventsContextValue>({
  fetchEvents: () => {},
});

export default EventsContext;
